import { render, staticRenderFns } from "./ShareWishlistModal.vue?vue&type=template&id=a5539448"
import script from "./ShareWishlistModal.vue?vue&type=script&lang=js"
export * from "./ShareWishlistModal.vue?vue&type=script&lang=js"
import style0 from "./ShareWishlistModal.vue?vue&type=style&index=0&id=a5539448&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports